import React from 'react';
import { DEFAULT_PROJECT_NAME } from './dashboard/components/helpers';
import useProjectStore from '../store/projectStore';

function ProjectInfoBar() {
    const currentProjectId = useProjectStore(s => s.currentProjectId);
    const projects = useProjectStore(s => s.projects);
    const prjName = projects?.find(f => f.id == currentProjectId)?.name || (localStorage.lastProjectName || DEFAULT_PROJECT_NAME);
    return (
        <div
        className={"projectInfoBar"}
         style={{
            margin: 0,
            marginLeft: 2,
            marginTop: -62,
            width: "calc(100% - 10px)",
            height: "20px",
            maxHeight: "20px",
            fontSize: "14px",
            // backgroundColor: "rgba(255,255,255,0.18)",
            borderRadius: "4px",
            padding: 4,
            textAlign: "center",
            display: "inline-block",
            position: "absolute",
        }}>
            <div
            className={"projectInfoBarActive"}
            style={{
                maxHeight: "42px",
                marginTop: 2,
                fontSize: `${prjName.length > 10 ? "8px" : "14px"}`,
                overflow: "scroll",
            }}
            >{ prjName }</div>
            <div style={{
                display: "inline-block",
                width: "calc(100% - 10px)",
                height: "100%",
                marginTop: -4,
                borderRadius: "4px",
                padding: 4,
               fontSize: 10,

                whiteSpace: "nowrap",
                overflow: "hidden",

            }}>
                ESTATE
            </div>

        </div>
    )
}

export default ProjectInfoBar;